import Slider, { SliderSingleProps } from 'antd/es/slider';
import clsx from 'clsx';

import './OpSlider.scss';

interface OpSliderProps extends SliderSingleProps {
  testId?: string;
}

/**
 * OpSlider is a wrapper around Ant Design's Slider component.
 * It provides a sliding input for selecting a value from a continuous or discrete range.
 * 
 * Use this component for adjusting settings, selecting values within a range, or creating interactive controls
 * where visual feedback of the selected value is important.
 * 
 * @example
 * <OpSlider
 *   min={0}
 *   max={100}
 *   value={value}
 *   onChange={handleChange}
 *   marks={{ 0: '0', 100: '100' }}
 * />
 * 
 */
export const OpSlider = ({
  className,
  testId = 'op-slider',
  ...rowProps
}: OpSliderProps) => {
  return (
    <div data-testid={testId} className={clsx('op-slider', className)}>
      <Slider {...rowProps} />
    </div>
  );
};
